<div class="flex layout-column"><router-outlet></router-outlet></div>